<template>
  <Modal
  :id="'cmp-dt-add-task'" 
    @cancelled="onCancel"
  >
    <template slot="header">
      
      {{ task.task }} <br/>

      {{item_name}}

    </template>

    <template slot="body">
      
        <TextField
          class="m1"
          :id="'task'"
          v-bind="textFieldConfig"
          :value="task.task"
          :placeholder="$dft.capHead($t('task'))"
          @valuechanged="onTextFieldValueChange"
          :showValidationIcons="false"
          :immediateValidation="true"
          v-if="!task.task_template_id"
        />	
        <Dropdown
          :options="statusTV"
          class="m2"
          :selected="
                statusTV.find(v => v.value == task.status)
              "
          :placeholder="$t('status')"
          v-on:selectedChange="e => onDropdownChange('status', e)"
          :listHeight="120"
          box
        />

        <Dropdown
          :options="usersTV"
          class="m2"
          :selected="assignedUserSelectedTV"
          :placeholder="$t('assigned_user')"
          v-on:selectedChange="e => onDropdownChange('assigned_user', e)"
          :listHeight="120"
          box
          multiple
        />
        
        <TextField
          type="date"
          id="due_date"
          class="m1"
          :placeholder="$t('due_date')"
          :value="task.due_date"
          @valuechanged="onTextFieldValueChange"
        />
        <TextField
          class="m1"
          :id="'notes'"
          v-bind="textFieldConfig"
          :value="task.notes"
          :placeholder="$t('notes')"
          @valuechanged="onTextFieldValueChange"
          :showValidationIcons="false"
          :immediateValidation="true"
          :disable="true"
        />

        <template v-for="(item,index) in extra_fields">
            <template v-if="item.data_type=='decimal'">
              <TextField
                class="m1 number"
                :id="index"
                :type="'number'"
                v-bind="textFieldConfig"
                :value="item.field_data"
                :validators="decimalValidators"
                :placeholder="item.field_name"
                @valuechanged="onExtraFieldValueChange"
                @validated="onValidation"
              />
              <!--  -->
              <!-- :disable="true" -->
            </template>
            <template v-if="item.data_type=='int'">
              <TextField
                class="m1 number"
                :id="index"
                :type="'number'"
                v-bind="textFieldConfig"
                :value="item.field_data"
                :validators="intValidators"
                :placeholder="item.field_name"
                @valuechanged="onExtraFieldValueChange"
                @validated="onValidation"
                
              />
              <!--  -->
              <!-- :disable="true" -->
            </template>
            
            <template v-if="item.data_type=='email'">
              <div class="ut-flex">
                <TextField
                  class="m1"
                  :id="index"
                  v-bind="textFieldConfig"
                  :value="item.field_data"
                  :validators="emailValidators"
                  :placeholder="item.field_name"
                  @valuechanged="onExtraFieldValueChange"
                  @validated="onValidation"
                  style="flex: 9;"
                />
                <div class="dt-icon-container" style="flex: 1;margin-left: 20px;" @click="onEmailClick(item.field_data)">
                  <img
                    src="static/icons/email-blue.svg"
                    class="dt-icon v5 s2"
                    alt="name"
                    title="Company Name"
                  />
                </div>
              </div>
              <!-- :disable="true" -->
            </template>
            <template v-if="item.data_type=='text'">
              <TextField
                class="m1"
                :id="index"
                
                v-bind="textFieldConfig"
                :value="item.field_data"
                :placeholder="item.field_name"
                @valuechanged="onExtraFieldValueChange"
                
              />
              <!-- :disable="true" -->
            </template>
            <template v-if="item.data_type=='text_box'">
              <TextField
                class="m1"
                :id="index"
                textarea
                
                v-bind="textFieldConfig"
                :value="item.field_data"
                :placeholder="item.field_name"
                :height="100"
                @valuechanged="onExtraFieldValueChange"
               
              />
            </template>
            <template v-if="item.data_type=='date'">
              <TextField
                class="m1"
                :id="index"
                type="date"
                
                :value="item.field_data"
                :placeholder="item.field_name"
                
                @valuechanged="onExtraFieldValueChange"
                
              />
            <!-- :validators="dateValidators" -->
            <!-- @validated="onValidation" -->
            </template>
            <template v-if="item.data_type=='check_box'">
              <DTCheckbox
                :id="item.field_name"
                :label="item.field_name"
                :checked="item.field_data==1||item.field_data=='1'"
                @click="e=>onCheckboxChange(index,e)"
                :minH="'42px'"
                :class="'ml0'"
              />
              <!-- :disable="true" -->
            </template>
        </template>

        <TextField
          v-if="task.external_table!='booking'"
          class="m1"
          :id="'from'"
          v-bind="textFieldConfig"
          :value="sender"
          :placeholder="$dft.capHead($t('from'))"
          @valuechanged="onTextFieldValueChange"
          :showValidationIcons="false"
          :immediateValidation="true"
          :disabled="true"
         
        />
        <!-- {{extra_fields  }} -->
        

    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button 
        class="dt-button v1 s6" 
        @click.stop="onTaskTemplateSubmit"
        :class="{ disabled: !IsFormValid }"
        :disabled="!IsFormValid"
      >
        {{ $t("ok") }}
      </button>
    </template>
  </Modal>
</template>
<!--  -->
<script>
import Modal from "@dtplugins/modal/modal";
import { taskService } from "../../modules/tasks/services/tasks.service";
import { dtTaskService } from "./dt-task-service";
import DTCheckbox from "@plugins/checkbox/checkbox";
import { format } from "date-fns";
import isEmail from "validator/lib/isEmail";
import isFloat from "validator/lib/isFloat";
import isInt from "validator/lib/isInt";
//import isDate from "validator/lib/isDate";
import { createValidator } from "@plugins/text-field";
import { sendMailHref } from "../../utility";
import { decimalValidators ,intValidators,emailValidators} from "../../utility/custom.validator"
export default {
  components: {
    Modal,
    DTCheckbox
  },
  props: {},
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
      },
      task:  {
        task: "",
        due_date: "",
        assigned_users: "",
        sent_user: "",
        status: "open",
        external_table:"general",
        due_date:format(new Date(), "YYYY-MM-DD")
      },

      item_name:"",
      sender:"",
      formData: {},

      userArray:[],

      extra_fields:[],
      emailValidators:emailValidators,

      intValidators:intValidators,

      decimalValidators:decimalValidators,

      jsonValidationResult: {},
     
      
    };
  },
  mounted: async function() {
    const formData = await dtTaskService.loadTaskSingle(this.task_id);

    console.log("::::::::::::::::::::::::PPPPPPPPAAAAAA",formData)

    this.task = { ...formData.data.task}

    this.item_name = formData.data.item_name;

    this.sender = formData.data.sender;

    const assignedUserData = await taskService.tasksTab();


    this.userArray = assignedUserData.data.users


    const taskExtraField = this.task.json_data?.extra_fields?  this.task.json_data?.extra_fields:[];
    
    const formExtraField = formData.data.extra_fields||[];

    console.log(formExtraField,"::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::",assignedUserData)

    this.extra_fields = formExtraField.map(x=>{
      const taskField = taskExtraField.find(y=>y.field_UUID==x.field_UUID)
      if(taskField){
        return {
          ...taskField
        }
      }else{
        return{
          ...x
        }
      }
    })
    console.log("POIUUYJHG",this.task,assignedUserData,this.extra_fields)
  },
  computed: {
    task_id: function () {
       return this.$route.query.task_id;
    },
    usersTV(){
      return (this.userArray || []).map(r => ({text: r.user_name, value: r.user_id}));
    },
    assignedUserSelectedTV(){
      const assignedUserArr = this.task?.assigned_users ? this.task.assigned_users.split(',') : [];
      return this.usersTV.filter( userTV => assignedUserArr.includes("" + userTV.value) ) || [];
    },
    statusTV: function() {
      return [
          {text:'open',value:'open'},
          {text:'pending',value:'pending'},
          {text:'question',value:'question'},
          {text:'done',value:'done'},
          {text:'rejected',value:'rejected'},
        ]
    },
    IsFormValid: function () {
      return Object.values(this.jsonValidationResult).every((e) => e.valid)
    },
  },
  methods: {
    formatD(value){
      return format(new Date(value),'YYYY-MM-DD')
    },
    onValidation: function (name, value) {
      // console.log("per validate", { name, value });
      this.$set(this.jsonValidationResult, name, value);
    },
    onTaskTemplateSubmit:async function() {
      
      const task = {...this.task , extra_fields:JSON.stringify(this.extra_fields) }

      dtTaskService.updateSingleTaskExtraFiled({...task});
      await dtTaskService.updateSingleTask({...task});

      this.$emit('onSubmit',{...task,item_name:this.item_name , chapter:this.$t(task.external_table) , source:this.item_name})

      this.onCancel()
  
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function(id, value) {
      this.task[id] = value;
   

    },
    onDropdownChange: function(name, value) {
      let val = value.value;
      let namevalue = "";
      if(['assigned_user', 'local_detail_type_ids'].includes(name)){
        val = value.map(r => r.value).join();
        namevalue =value.map(r => r.text).join();
        
        console.log("val",value)
        name = 'assigned_users'
      }
      this.task[name] = val;

    },
    onCheckboxChange: function(name, event) {
      const val = event.target.checked ? 1 : 0;
      this.extra_fields[name].field_data = val;
   
    },

    onExtraFieldValueChange:function(e,value){
      this.extra_fields[e].field_data=value
      console.log(this.extra_fields,"EXTRA FIELD",e)

    },

    onEmailClick:function(email){
      console.log("EMAIL",email,`${this.task.task} | ${this.item_name}`)
      if(email && email!='')
        sendMailHref({subject:`${this.task.task} | ${this.item_name}` ,body:`${this.task.task} | ${this.item_name}`,mails:[email]})
    }

  }
};
</script>

<style lang="scss">
.cmp-dt-add-task {
  .dt-checkbox-control {
    display: flex;
    padding-top: 12px;
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }
  .number{
    input{
      text-align: right;
    }
  }
}
</style>
